import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
    override changes = new Subject<void>();
    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            this.itemsPerPageLabel = `Showing 0 of ${length} entries`;
            this.changes.next(); // Notify changes
            return `0 of ${length}`;
        }

        const startIndex = page * pageSize + 1;
        const endIndex = Math.min(startIndex + pageSize - 1, length);

        this.itemsPerPageLabel = `Showing ${startIndex} to ${endIndex} of ${length} entries`;
        this.changes.next(); // Notify changes

        return `${startIndex} - ${endIndex} of ${length}`;
    };

    overridePageSizeOptions (pageSizeOptions: number[]): string[] {
        return pageSizeOptions.map(option => `Show ${option}`);
    }
}
